module.exports = __webpack_public_path__ + "static/img/img1en.8a40ef3c.png";